import { Antwoord, Controltype, Herstelbedrijf, Vraag, Vraagtype } from '@models/claims';
import { VraagboomAntwoord, VraagboomEmptyResultaat, VraagboomReparateurResultaat } from '@models/vragenboom';

export class HiddenVraagMapper {
  public static map(hiddenVraag: Vraag): VraagboomAntwoord<VraagboomEmptyResultaat> {
    if (hiddenVraag == null || hiddenVraag.tonen) {
      return null;
    }
    let resultaat;
    if (hiddenVraag.control === Controltype.SingleChoiceRepair || hiddenVraag.control === Controltype.SingleChoiceRepairWithSearch) {
      let relnr = '';
      let rol = '';
      hiddenVraag.antwoorden?.forEach((antwoord: Antwoord) => {
        if (antwoord.soortLijst?.herstelbedrijven) {
          let herstellers = antwoord.soortLijst.herstelbedrijven as Herstelbedrijf[];
          if (herstellers?.length === 1) {
            relnr = herstellers[0].relatienummer;
            rol = herstellers[0].rol;
          };
        }
      });
      resultaat = new VraagboomAntwoord<VraagboomReparateurResultaat>();
      resultaat.vraag = hiddenVraag;
      resultaat.resultaat = new VraagboomReparateurResultaat(relnr, rol, "", "", false);
      resultaat.antwoorden = hiddenVraag.antwoorden;
    } else {
      resultaat = new VraagboomAntwoord<VraagboomEmptyResultaat>();
      resultaat.vraag = hiddenVraag;
      resultaat.resultaat = new VraagboomEmptyResultaat();
      resultaat.antwoorden = [];
      if (hiddenVraag.antwoorden != null) {
        resultaat.antwoorden.push(hiddenVraag.antwoorden.find(a => a.standaard_waarde === 'True'));
      }
    }
    return resultaat;
  }
}
